import React, { useState, useEffect } from 'react'
import { API, Auth } from 'aws-amplify';
import { NavLink} from "react-router-dom";
import "@aws-amplify/ui-react/styles.css";
import "react-datepicker/dist/react-datepicker.css";
import { Flex, Divider, Text, Heading, View, Button} from '@aws-amplify/ui-react';
//import Loading from '../components/loading';
import Loadingmini from '../components/loadingmini';
import { AgGridReact } from 'ag-grid-react'; // React Data Grid Component
//import "ag-grid-community/styles/ag-grid.css"; // Mandatory CSS required by the grid
import { themeQuartz } from 'ag-grid-community'; //import "ag-grid-community/styles/ag-theme-quartz.css"; // Optional Theme applied to the grid

export default function Insuranceendorsements() {
    const [is_loading, updateIsLoading] = React.useState(false);
    const [count, setCount] = useState(0);
    const [res, updateRes] = useState({status:"Contact support if this message stays for more than 30 seconds",alerts:[]})
    const [driverName, updateDriverName] = React.useState(false);
    const [endorsementId, updateEndorsementId] = React.useState(false);
    const [displayConfirmApprove, updateDisplayConfirmApprove] = React.useState(false);
    const [displayConfirmDeny, updateDisplayConfirmDeny] = React.useState(false);
    
/*
    const columns = [
        {
            headerName: 'Driver Name',
            field: 'name_full',
            filter: true,
            width: 200
        },
        {
            headerName: 'Phone',
            field: 'phone',
            filter: true,
            width: 200
        },
        {
            headerName: 'Email',
            field: 'email',
            filter: true,
            width: 200
        },
        {
            headerName: 'Approve / Deny',
            width: 200,
            field: 'request_id',
            filter: true,
            cellRenderer: params => {
                let requestId = params.value
                let requestIdStr = String(requestId)
                return( 
                    <View>
                        <Button onClick={() => showConfirmApprove(requestIdStr)}>
                            APPROVE
                        </Button>
                        <br/>
                        <br/>
                        <Button onClick={() => showConfirmDeny(requestIdStr)}>
                            DENY
                        </Button>
                        <br/>
                    </View>
                )
            }
        },
        {
            headerName: 'Requested',
            field: 'created',
            filter: true,
            width: 200
        },
        {
            headerName: 'Policy Number',
            field: 'policy_number',
            filter: true,
            width: 200
        },
    ];
*/


    async function showConfirmApprove(requestId)
    {
        updateIsLoading(true)
        //console.log('request id: '+requestId)
        let session = await Auth.currentSession()      
        let accessToken = session.getAccessToken()
        let jwt = accessToken.getJwtToken()
        const myInit = {queryStringParameters:{ 
            "back_end": process.env.REACT_APP_BACKEND,
            "jwt": jwt,
            "api_endpoint": "api3:staff:insurance_endorsements",
            "request_type":"GET",
            "endorsement_id":requestId
        }};
        try {
            const res = await API.get('adminWebTools','/ago',myInit)
            //console.log(JSON.stringify(res))
            updateDriverName(res.resp[0]['name_full'])
            updateEndorsementId(requestId)
            updateDisplayConfirmApprove(true)
            updateIsLoading(false)
        }
        catch (e) {
            console.log('error: '+JSON.stringify(e))
            updateIsLoading(false)
        }
    }

    async function showConfirmDeny(requestId)
    {
        updateIsLoading(true)
        //console.log('request id: '+requestId)
        let session = await Auth.currentSession()      
        let accessToken = session.getAccessToken()
        let jwt = accessToken.getJwtToken()
        const myInit = {queryStringParameters:{ 
            "back_end": process.env.REACT_APP_BACKEND,
            "jwt": jwt,
            "api_endpoint": "api3:staff:insurance_endorsements",
            "request_type":"GET",
            "endorsement_id":requestId
        }};
        try {
            const res = await API.get('adminWebTools','/ago',myInit)
            //console.log(JSON.stringify(res))
            updateDriverName(res.resp[0]['name_full'])
            updateEndorsementId(requestId)
            updateDisplayConfirmDeny(true)
            updateIsLoading(false)
        }
        catch (e) {
            console.log('error: '+JSON.stringify(e))
            updateIsLoading(false)
        }

    }

    async function fetchPageData() {
        updateIsLoading(true)
        let session = await Auth.currentSession()      
        let accessToken = session.getAccessToken()
        let jwt = accessToken.getJwtToken()
        const myInit = {queryStringParameters:{ 
            "back_end": process.env.REACT_APP_BACKEND,
            "jwt": jwt,
            "api_endpoint": "api3:staff:insurance_endorsements",
            "request_type":"GET"
        }};
        try {
            const res = await API.get('adminWebTools','/ago',myInit)
            //console.log(JSON.stringify(res))
            updateRes(res)
            updateIsLoading(false)
        }
        catch (e) {
            if(typeof(e) !== 'undefined')
            {
                console.log('error: '+toString(e));
            } else {
                console.log('error - unknown error');
            }
            updateIsLoading(false)
        }
    }

    useEffect(() => {
        fetchPageData()
    },[count])
    

    async function sendApprove()
    {
        updateIsLoading(true)
        let session = await Auth.currentSession()      
        let accessToken = session.getAccessToken()
        let jwt = accessToken.getJwtToken()
        const myInit = {queryStringParameters:{ 
            "back_end": process.env.REACT_APP_BACKEND,
            "jwt": jwt,
            "api_endpoint": "api3:staff:insurance_endorsements",
            "request_type":"POST",
            "endorsement_id":endorsementId,
            "status":"approved"
        }};
        try {
            const res = await API.get('adminWebTools','/ago',myInit)
            updateDriverName(false)
            updateEndorsementId(false)
            updateDisplayConfirmDeny(false)
            updateDisplayConfirmApprove(false)
            fetchPageData()
        }
        catch (e) {
            console.log(JSON.stringify(e))
            updateIsLoading(false)
        }
    }

    async function sendDeny()
    {
        updateIsLoading(true)
        let session = await Auth.currentSession()      
        let accessToken = session.getAccessToken()
        let jwt = accessToken.getJwtToken()
        const myInit = {queryStringParameters:{ 
            "back_end": process.env.REACT_APP_BACKEND,
            "jwt": jwt,
            "api_endpoint": "api3:staff:insurance_endorsements",
            "request_type":"POST",
            "endorsement_id":endorsementId,
            "status":"denied"
        }};
        try {
            const res = await API.get('adminWebTools','/ago',myInit)
            updateDriverName(false)
            updateEndorsementId(false)
            updateDisplayConfirmDeny(false)
            updateDisplayConfirmApprove(false)
            fetchPageData()
        }
        catch (e) {
            console.log(JSON.stringify(e))
            updateIsLoading(false)
        }
    }

    function _renderEndorsements()
    {
      if(!res.resp){
        return;
      }
      return res.resp.map(function(object, index){
        return(
            <View>
                <Heading level={4}>{object.name_full}</Heading>
                <Text>{object.phone}</Text>
                <Text>{object.email}</Text>
                <Text>{object.license}</Text>
                <Text>requested: {object.created}</Text>
                <Text>policy: {object.policy_number}</Text>
                <br/>
                <View>
                    <Button onClick={() => showConfirmApprove(object.request_id)}>
                        APPROVE
                    </Button>
                    <br/>
                    <br/>
                    <Button onClick={() => showConfirmDeny(object.request_id)}>
                        DENY
                    </Button>
                    <br/>
                </View>
                <br/>
                <Divider />
            </View>
        )
      })
    }

  return (
      <Flex
        direction="column"
      >
        <View style={{padding:"1rem"}}>
            <Flex 
                direction='column'
            >
                <Heading level={1}>Endorsement Requests</Heading>
                <Text style={{width:'100%'}}>These are insurance endorsements awaiting your approval or denial.</Text>
                <View>
                    <Button onClick={() => setCount(count + 1)}>
                        PRESS TO GET LATEST UPDATES
                    </Button>
                </View>
                <Flex direction="column" style={{width:"80vw",maxWidth:"2200px"}}>
                    <Divider />
                    {
                        displayConfirmApprove ? 
                            <View>
                                <Heading level={2}>Are you sure?</Heading>
                                <Text>Are you sure you'd like to approve driver {driverName}?</Text>
                                <br/>
                                <View>
                                    <Button onClick={() => sendApprove()}>
                                        CONFIRM
                                    </Button>
                                </View>
                                <br/>
                                <View>
                                    <Button onClick={() => updateDisplayConfirmApprove(false)}>
                                        CANCEL
                                    </Button>
                                </View>
                            </View>
                        :
                        displayConfirmDeny ? 
                            <View>
                                <Heading level={2}>Are you sure?</Heading>
                                <Text>Are you sure you'd like to deny driver {driverName}?</Text>
                                <br/>
                                <View>
                                    <Button onClick={() => sendDeny()}>
                                        CONFIRM
                                    </Button>
                                </View>
                                <br/>
                                <View>
                                    <Button onClick={() => updateDisplayConfirmDeny(false)}>
                                        CANCEL
                                    </Button>
                                </View>
                            </View>
                        :
                            <View 
                                theme={themeQuartz} //className="ag-theme-quartz" // applying the grid theme
                                style={{ height: 500 }} // the grid will fill the size of the parent container
                            >
                                {
                                    is_loading ? <Loadingmini /> : 
                                    !res ? <Text>You have no incomplete endorsement requests</Text> :
                                    !res.resp ? <Text>You have no incomplete endorsement requests</Text> :
                                    res.resp.length > 0 === false ? <Text>You have no incomplete endorsement requests</Text> :
                                    _renderEndorsements()
                                }
                            </View>
                    }
                </Flex>
            </Flex>
        </View>
      </Flex>
  );
}
